"use client";

export async function hashEmail(email: string): Promise<string> {
  const normalised = email.trim().toLowerCase();
  const encoded = new TextEncoder().encode(normalised);
  const buffer = await crypto.subtle.digest("SHA-256", encoded);
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}
